__turbopack_context__.v({
  "divider": "styles-module__8NtzgG__divider",
});
